export { default } from "./AdSlot";
